// @flow

import type { AppType } from "shared/types/AppType"

export default ({
  asyncComponentResolve: () => import("apps/orders/OrdersEntry"),
  iconType: "profile",
  name: "orders",
  subApps: [
    {
      name: "order-search",
      requirePermission: "orders:order-search"
    },
    {
      name: "manage-orders",
      requirePermission: [
        "orders:manage-all-fleets",
        "orders:manage-admin-fleets"
      ]
    }
  ]
}: AppType)
